angular.module('impactx.product').controller('ProductImageGalleryCtrl', [
    '$mdDialog',
    '$timeout',
    ProductImageGalleryController
]);

function ProductImageGalleryController($mdDialog, $timeout) {
    var self = this;

    var imageUrl = self.product.imageUrl && typeof self.product.imageUrl === 'object' ? self.product.imageUrl.url
        : self.product.imageUrl;
    self.selectedProductMedia = self.mediaList.filter(function (entry) {
        return entry.url == imageUrl;
    })[0] || self.mediaList[0];
    var scrollPositionIndex = Math.max(0, self.mediaList.indexOf(self.selectedProductMedia) - 4);
    self.THUMBNAIL_WIDTH = 75;

    self.scrollContainerHeight = self.mediaList.length > 5 ? '375px' : self.THUMBNAIL_WIDTH * self.mediaList.length + 'px';
    $timeout(setScrollTop, 200);

    self.handleKeyDown = function (event) {
        if (event) {
            // keycode 37 and 38 are left and up arrow key
            if (event.keyCode == 37 || event.keyCode == 38) {
                selectPreviousMedia();
            }
            // keycode 39 and 40 are right and down arrow key
            else if (event.keyCode == 39 || event.keyCode == 40) {
                selectNextMedia();
            }
        }
    };

    self.selectMedia = function (media) {
        self.hasChanged = true;
        $timeout(function () {
            self.hasChanged = false;
        });
        self.selectedProductMedia = media;
    };

    self.close = function () {
        $mdDialog.hide();
    };

    self.scrollDown = function () {
        if (scrollPositionIndex < (self.mediaList.length - 5)) {
            scrollPositionIndex++;
            setScrollTop();
        }
    };

    self.scrollUp = function () {
        if (scrollPositionIndex > 0) {
            scrollPositionIndex--;
            setScrollTop();
        }
    };

    function setScrollTop() {
        var scrollArea = angular.element('#image-scroll-area')[0];
        if (scrollArea) {
            scrollArea.style.top = '-' + self.THUMBNAIL_WIDTH * scrollPositionIndex + 'px';
        }
    }

    function selectPreviousMedia() {
        var index = self.mediaList.indexOf(self.selectedProductMedia);

        if (index > 0) {
            self.selectMedia(self.mediaList[index - 1])
            if (index <= scrollPositionIndex) {
                self.scrollUp();
            }
        }
    }

    function selectNextMedia() {
        var index = self.mediaList.indexOf(self.selectedProductMedia);

        if (index >= 0 && (index + 1) < self.mediaList.length) {
            self.selectMedia(self.mediaList[index + 1]);

            if (index + 1 >= scrollPositionIndex + 5) {
                self.scrollDown();
            }
        }
    }
}